import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 97 96"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M.6 48C.8 20.8 22.9.2 48.6.3 76 .5 96.5 23.1 96.2 48.6c-.4 26.5-22.3 47.5-48.3 47.2C21.6 95.5.6 74 .6 48ZM48.4 5.9C25 5.9 6.1 24.9 6.1 48.2c.1 23.4 19 42.3 42.4 42.2 23.3-.1 42.2-19 42.1-42.3 0-23.4-18.9-42.3-42.2-42.2Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M24.3 55c.4 0 .8-.1 1.2-.1H71c1 0 1.3.2 1.3 1.2.1 6.2-1.2 12-4.6 17.3-3.4 5.3-8.3 8.2-14.5 9-4.9.6-9.6.1-14-1.9-6-2.8-9.7-7.6-12.3-13.5-1.6-3.8-2.4-7.8-2.6-12Zm6.3 5.5c.4 1.2.6 2.2 1 3.3C34.4 71.5 40 77 49.2 77.1c3 0 5.9-.4 8.6-1.8 3.7-2 5.9-5.1 7.3-9 .7-1.9 1.1-3.8 1.6-5.8H30.6ZM32.7 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4ZM64.9 48.5a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "SmileyRate5"}) } }